import { useQuery } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'
import { type EmployeeWithPaySchedules } from '../payroll/types'
import { getBasePaySchedulesQuery } from './payroll/utils'

type UnassignedEmployeesResponse = {
  data: EmployeeWithPaySchedules[]
  employer_requires_pay_schedule_assignment: boolean
}

export function useGetUnassignedEmployees () {
  return useQuery<UnassignedEmployeesResponse, GrapeAPIErrorType>({
    queryKey: [...getBasePaySchedulesQuery(), 'unassignedEmployees'],
    queryFn: async () => {
      const response = await fetchWithHeaders('/api/web/payroll/unassigned_employees')

      if (!response.ok) {
        const errorJson = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errorJson.message,
          errors: errorJson.errors
        })
      }

      return response.json()
    },
  })
}
